import {css} from 'styled-components';
import {externalBannerHeight} from './externalBanner';

export const BANNER_HEIGHT = 40;

// Slightly under BANNER_HEIGHT so content sits flush against the last banner
// (a hairline visual gap otherwise remains at some breakpoints).
export const BANNER_CONTENT_OFFSET = 36;

export const sidebarAwareInset = css`
  left: 210px;
  width: calc(100% - 210px);
  @media (max-width: 1250px) {
    left: 0;
    width: 100%;
  }
`;

const anchor = (fallback, extra) => css`
  top: calc(var(--banner-stack-top, ${fallback}px) ${extra});
`;

const externalTop = (fallback) => anchor(fallback, '');

const stackTop = (fallback) =>
  anchor(
    fallback,
    ` + ${externalBannerHeight} +
      (var(--banner-stack-index, 0) * ${BANNER_HEIGHT}px)`
  );

export const externalBannerPosition = css`
  position: fixed;
  ${sidebarAwareInset}
  ${externalTop(56)}
  z-index: 15;
  box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.2);

  @media (max-width: 1250px) {
    ${externalTop(64)}
  }
  @media (max-width: 599px) {
    ${externalTop(90)}
  }
`;

export const bannerFixedPosition = css`
  position: fixed;
  ${sidebarAwareInset}
  ${stackTop(56)}
  z-index: 15;
  box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.2);

  @media (max-width: 1250px) {
    ${stackTop(64)}
  }
  @media (max-width: 599px) {
    ${stackTop(90)}
  }
`;
